import { useEffect } from "react";

export default function useEcpayInit() {
  useEffect(() => {
    if ("ecpay" !== import.meta.env.VITE_PAYMENT_SERVICE_PROVIDER) {
      return;
    }
    
    // If ECPay is already loaded and initialized, don't reset it
    if (window.ECPay && window.ECPayLoaded) {
      return;
    }
    
    window.ECPayLoaded = false;
    // Step 1: 確認 html 裡有 <div id="ECPayPayment"></div>
    // Step 2: 載入 jQuery（如未載入）
    function loadJQuery() {
      return new Promise((resolve) => {
        if (window.jQuery) {
          resolve();
        } else {
          const script = document.createElement("script");
          script.src = "https://code.jquery.com/jquery-3.5.1.min.js";
          script.onload = resolve;
          document.body.appendChild(script);
        }
      });
    }
    // Step 3: 載入 ECPay JS SDK（依 VITE_TAPPAY_ENV 切換，未載入才插入）
    function loadECPaySDK() {
      return new Promise((resolve) => {
        if (window.ECPay) {
          resolve();
        } else {
          const script = document.createElement("script");
          script.id = "ecpay-sdk-script";
          script.src =
            import.meta.env.VITE_TAPPAY_ENV === "production"
              ? "https://ecpg.ecpay.com.tw/Scripts/sdk-1.0.0.js?t=20210121100116"
              : "https://ecpg-stage.ecpay.com.tw/Scripts/sdk-1.0.0.js?t=20210121100116";
          script.onload = resolve;
          document.body.appendChild(script);
        }
      });
    }
    // step4: 呼叫 ECPay.initialize()
    function initializeECPay() {
      const isProd = import.meta.env.VITE_TAPPAY_ENV === "production";
      window.ECPay.initialize(
        isProd ? "Prod" : "Stage",
        1,
        function callBack(errMsg) {
          if (errMsg !== null) {
            console.log("ECPay 初始化失敗:", errMsg);
            window.ECPayLoaded = false;
          } else {
            console.log("ECPay 初始化成功");
            window.ECPayLoaded = true;
          }
        },
      );
    }
    // 載入 jQuery 和 ECPay SDK
    loadJQuery().then(loadECPaySDK).then(initializeECPay);
  }, []);
}
